export default ['https://api.vtbs.moe', 'https://cfapi.vtbs.moe', 'https://hkapi.vtbs.moe'];
